export default {
      id: "lider-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "sprite.svg#lider-usage",
      toString: function () {
        return this.url;
      }
    }